import { switchMap, catchError, of, firstValueFrom } from 'rxjs';
import { fromFetch } from 'rxjs/fetch';
import { validateEmail } from 'constants/routes';

function validateEmailAddress(email) {
  const observable$ = fromFetch(validateEmail, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    },
    body: JSON.stringify({ emailAddress: email }),
  }).pipe(
    switchMap((response) => response.json()),
    catchError(() => of(true))
  );

  return firstValueFrom(observable$);
}

export default validateEmailAddress;